export default __webpack_public_path__ + "static/media/pexels-kaboompics-com-6253.75daf229.jpg";